module.exports = __webpack_public_path__ + "static/media/13.9c1f842c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/13.jpg
// module id = 546
// module chunks = 0